import { Progress } from '@chakra-ui/react';
import React, { useContext, useEffect, useState } from 'react';
import { CbButton } from 'ui/components/Buttons/CbButton';
import { CbGuideCard } from 'ui/components/CbGuideCard';
import { ICON_BY_NAME } from 'ui/components/Icons/Icon';
import { GuideContext } from '../GuideContainer';
import styles from './MobileNavigationContainer.module.css';
export const MobileNavigationContainer = () => {
  const {
    answerQuestion,
    canGoNext,
    canGoPrev,
    cardIndex,
    cards,
    guide,
    nextPage,
    prevPage,
    shouldShowPrev,
    startOver
  } = useContext(GuideContext);
  const [isLandscape, setIsLandscape] = useState(false);
  const [videoCardActive, setVideoCardActive] = useState(false);
  useEffect(() => {
    function handleOrientationChange() {
      setIsLandscape(window.innerWidth > window.innerHeight);
    }
    window.addEventListener('resize', handleOrientationChange);
    window.addEventListener('orientationchange', handleOrientationChange);
    handleOrientationChange();
    return () => {
      window.removeEventListener('resize', handleOrientationChange);
      window.removeEventListener('orientationchange', handleOrientationChange);
    };
  }, []);
  useEffect(() => {
    if (cards[cardIndex]?.format === 'video') {
      setVideoCardActive(true);
    }
  }, [cards[cardIndex]?.format]);
  if (guide === undefined || cards === undefined) {
    return null;
  }
  const onCardClick = (e: React.MouseEvent<HTMLDivElement>) => {
    const {
      clientX,
      clientY
    } = e;
    const isLeft30X = clientX < window.innerWidth * 0.3;
    const isRight60X = clientX > window.innerWidth * 0.4;
    const isMiddle70Y = clientY > window.innerHeight * 0.05 && clientY < window.innerHeight * 0.95;
    if (isLeft30X && isMiddle70Y) {
      return canGoPrev && prevPage();
    }
    if (isRight60X && isMiddle70Y) {
      return canGoNext && nextPage();
    }
  };
  return <>
      <div className={styles.container}>
        <div className={styles.navigationContainer} onClick={onCardClick}>
          <div className={styles.progressContainer}>
            <Progress className={styles.progress} size="xs" value={cardIndex + 0.25} max={cards.length - 0.75} colorScheme="blackAlpha" borderRadius="5px" background="rgba(0,0,0, 0.2)" data-sentry-element="Progress" data-sentry-source-file="MobileNavigationContainer.tsx" />
          </div>
          {cards.map((card, index) => {
          let visualIndex = index - cardIndex;
          return <CbGuideCard key={card.id} card={card} isActive={cardIndex === index} visualIndex={visualIndex} onAnswerQuestion={answerQuestion} />;
        })}
        </div>
        {cardIndex === cards.length - 1 && <div className={styles.returnTo}>Return to</div>}
        <CbButton className={styles.logoButton} variant="secondary" onClick={() => window.location.href = '/'} aria-label="Go to Arcade home" data-sentry-element="CbButton" data-sentry-source-file="MobileNavigationContainer.tsx">
          <ICON_BY_NAME.login fontSize={24} data-sentry-element="unknown" data-sentry-source-file="MobileNavigationContainer.tsx" />
        </CbButton>
        <div className={styles.footer}>
          {shouldShowPrev && <div className={styles.restartContainer} onClick={startOver} aria-label="Restart guide">
              <ICON_BY_NAME.restart fontSize={18} />
            </div>}
        </div>
      </div>
      {/* Allow landscape mode if viewing video content */}
      {!videoCardActive && isLandscape && <div className={styles.landscapeOverlay}>
          <p>We do not support small or horizontal screens at this time.</p>
        </div>}
      {cardIndex === 0 && <div className={styles.navigationControlOverlay} onClick={onCardClick}>
          <div className={styles.left}>
            <ICON_BY_NAME.chevronleft fontSize={32} data-testid={'guide-prev-button'} />
          </div>
          <div className={styles.right} data-testid={'guide-next-button'}>
            <ICON_BY_NAME.chevronright fontSize={32} />
          </div>
        </div>}
    </>;
};